// DepartmentNavbar.jsx
import React, { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

const navItems = [
  ["Home", "/"],
  ["Products", "/products"],
  // ["Featured Products", "/featuredproducts"],
  // ["Latest Products", "/latestproducts"],
    ["About Toshni", "/about-toshni"],
  ["Blogs", "/blogs-news"],
  ["Gallery", "/gallery-jewellery"],
  // ["Dashboard", "/seller"],
];



function slugify(text) {
  return text.toLowerCase().replace(/\s+/g, "-");
}

export default function DepartmentNavbar() {
  const location = useLocation();
  const [showDrop, setShowDrop] = useState(false);
  const [touchMode, setTouchMode] = useState(false);
  const dropRef = useRef(null);
  const titleRef = useRef(null);

  const all_categories_List = useSelector((state) =>
    state?.allapi?.all_categories_List ? state?.allapi?.all_categories_List : []
  );
  console.log(all_categories_List);
const DEPARTMENTS = all_categories_List
const DEPARTMENTSs = [
  {
    title: "Gold Jewellery",
    items: [
      {
        name: "Rings",
        sub: ["Engagement Rings", "Couple Rings", "Daily Wear Rings"],
      },
      {
        name: "Bracelets",
        sub: ["Handmade Bracelets", "Fancy Bracelets", "Kids Bracelets"],
      },
      {
        name: "Necklaces",
        sub: ["Long Necklaces", "Short Necklaces", "Party Wear"],
      },
      {
        name: "Kids Jewellery",
        sub: ["Kids Rings", "Kids Bangles"],
      },
    ],
  },
  {
    title: "Silver Jewellery",
    items: [
      {
        name: "Chains",
        sub: ["Light Chains", "Heavy Chains", "Oxidised Chains"],
      },
      {
        name: "Pendants",
        sub: ["Heart Pendant", "Initial Pendant", "Silver Drops"],
      },
      {
        name: "Anklets",
        sub: ["Thin Anklets", "Thick Anklets"],
      },
      {
        name: "Toe Rings",
        sub: ["Classic Toe Rings", "Modern Toe Rings"],
      },
    ],
  },
  {
    title: "Diamond Jewellery",
    items: [
      {
        name: "Earrings",
        sub: ["Stud Earrings", "Hoop Earrings", "Drop Earrings"],
      },
      {
        name: "Wedding Rings",
        sub: ["Couple Rings", "Engagement Rings"],
      },
      {
        name: "Elegant Sets",
        sub: ["Party Wear Sets", "Premium Sets"],
      },
    ],
  },
  {
    title: "Mens Section",
    items: [
      {
        name: "Men Bracelets",
        sub: ["Gold Bracelets", "Silver Bracelets"],
      },
      {
        name: "Men Rings",
        sub: ["Gold Rings", "Silver Rings"],
      },
      {
        name: "Men Chains",
        sub: ["Short Chains", "Long Chains"],
      },
    ],
  },
  {
    title: "Collections",
    items: [
      {
        name: "New Arrivals",
        sub: ["Gold New", "Silver New", "Diamond New"],
      },
      {
        name: "Trending",
        sub: ["Viral Styles", "Hot Selling"],
      },
      {
        name: "Gifts",
        sub: ["For Men", "For Women", "For Kids"],
      },
    ],
  },
];
  // Close on Esc
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setShowDrop(false);
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  // Detect touch devices to change hover behavior
  useEffect(() => {
    const isTouch = "ontouchstart" in window || navigator.maxTouchPoints > 0;
    setTouchMode(isTouch);
  }, []);

  // Close when clicking outside
  useEffect(() => {
    const onDocClick = (e) => {
      if (
        dropRef.current &&
        !dropRef.current.contains(e.target) &&
        titleRef.current &&
        !titleRef.current.contains(e.target)
      ) {
        setShowDrop(false);
      }
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  const handleTitleKey = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      setShowDrop((s) => !s);
    }
  };

  return (
    <div
      className="dept-navbar d-none d-lg-flex"
      onMouseLeave={() => !touchMode && setShowDrop(false)}
    >
      <div className="dept-container">
        {/* LEFT: hamburger + title */}
        <div
          className="dept-left d-flex align-items-center"
          ref={titleRef}
          onMouseEnter={() => !touchMode && setShowDrop(true)}
        >
          <button
            className="dept-hamburger"
            aria-label="Open menu"
            onClick={() => setShowDrop((s) => !s)}
          >
            <i className="fas fa-bars" />
          </button>

          <span
            className="dept-title "
            tabIndex={0}
            role="button"
            aria-expanded={showDrop}
            onClick={() => setShowDrop((s) => !s)}
            onKeyDown={handleTitleKey}
          >
            Shop by Category
          </span>
        </div>

        {/* CENTER LINKS */}
        <nav className="dept-links-wrap">
          <ul className="dept-links list-unstyled m-0 p-0 d-flex align-items-center">
            {navItems.map(([label, path]) => {
              const active = location.pathname === path;
              return (
                <li
                  key={path}
                  className={`dept-item ${active ? "active" : ""}`}
                  onMouseEnter={() => !touchMode && setShowDrop(false)}
                >
                  <Link to={path} className="dept-link">
                    {label}
                  </Link>
                </li>
              );
            })}
          </ul>
        </nav>
      </div>

      {/* MEGA DROPDOWN */}
      <div
        ref={dropRef}
        className={`dept-mega-dropdown bg-topheader ${showDrop ? "open" : "closed"}`}
        onMouseEnter={() => !touchMode && setShowDrop(true)}
        onMouseLeave={() => !touchMode && setShowDrop(false)}
      >
        <div className="dept-mega-container">
          {DEPARTMENTS.map((cat, index) => (
            <div key={index} className="dept-mega-col">
              <h4 className="mega-title">{cat.name}</h4>

              {cat.subcates.map((sub, i) => (
                <div key={i} className="mega-sub-block">
                  <h5 className="mega-sub-title">{sub.name}</h5>

                  <ul className="mega-list">
                    {sub.subjectss.map((item, j) => {
                      const slug = item?.cate_sulg;
                      const to = `/category-product/${slug}`;
                      const isActive =
                        location.pathname === to ||
                        location.pathname.includes(slug);
                      return (
                        <li key={j}>
                          <Link
                            to={to}
                            className={`mega-link ${isActive ? "active" : ""}`}
                            onClick={() => setShowDrop(false)}
                          >
                            {item?.name}
                          </Link>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
